import { useEffect } from 'react';
import {
  GlobalMenuItemsTypeEnum,
  useGlobalContextMenuStore,
} from '../store/globalContextMenuStore';
import { useChatTabsStore } from '../store/chatTabsStore';
import { createChatSelectionMention } from '../utils/chatSelectionMention';

const CHAT_SURFACE_SELECTOR = '[data-copilot-chat-surface]';
const EDITABLE_SELECTOR = 'input, textarea, [contenteditable="true"]';

export function readChatSelectionExcerpt({
  target,
  selection,
}: {
  target: EventTarget | null;
  selection: Selection | null;
}): string | null {
  if (!(target instanceof Element) || target.closest(EDITABLE_SELECTOR)) {
    return null;
  }

  const chatSurface = target.closest(CHAT_SURFACE_SELECTOR);

  if (!chatSurface || !selection || selection.isCollapsed) {
    return null;
  }

  if (
    selection.rangeCount === 0 ||
    !chatSurface.contains(selection.getRangeAt(0).commonAncestorContainer)
  ) {
    return null;
  }

  const excerpt = selection.toString().trim();

  return excerpt.length > 0 ? excerpt : null;
}

export function useChatSelectionContextMenu() {
  useEffect(() => {
    const handleContextMenu = (event: MouseEvent) => {
      if (event.defaultPrevented) {
        return;
      }

      const excerpt = readChatSelectionExcerpt({
        target: event.target,
        selection: window.getSelection(),
      });

      if (!excerpt) {
        return;
      }

      const { chatTabs, activeChatTabId } = useChatTabsStore.getState();
      const activeTab = chatTabs.find((tab) => tab.tabId === activeChatTabId);

      if (!activeTab) {
        return;
      }

      event.preventDefault();
      useGlobalContextMenuStore.getState().openMenu({
        x: event.clientX,
        y: event.clientY,
        items: [
          {
            type: GlobalMenuItemsTypeEnum.SEND_TO_CHAT,
            mention: createChatSelectionMention({
              chatId: activeTab.chatId,
              chatTitle: activeTab.title,
              excerpt,
            }),
          },
        ],
      });
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => document.removeEventListener('contextmenu', handleContextMenu);
  }, []);
}
